import React, { useState, useEffect, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  CardHeader,
  Button,
  CardContent,
  Divider,
  MenuItem,
  Grid,
  InputLabel, TableContainer, Paper, TableHead, TableRow, TableBody,
  TextField,
  Table,
  TableCell,
  Collapse,
  IconButton
} from '@material-ui/core';
import PageHeader from 'src/views/Common/PageHeader';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useAlert } from 'react-alert';
import Slide from '@material-ui/core/Slide';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _, { min } from 'lodash';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecordAndNew: {
    backgroundColor: "#FFBE00"
  },
  colorRecord: {
    backgroundColor: "green",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const screenCode = 'QUOTATIONCOMPLETE';

export default function QuotationCompleteAddEdit() {
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();

  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [suppliers, setSuppliers] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [QuotationDetailsData, setQuotationDetailsData] = useState([]);
  const [detailsOne, setDetailsOne] = useState([{ index: 0 }]);
  const [errors, setErrors] = useState({});
  const [quotationDetails, setQuotationDetails] = useState({
    groupID: '0',
    factoryID: '0',
    itemCategoryID: '0',
    itemID: '0',
    supplierID: '0',
    quotationHeaderID: 0,
    appliedType: '0',
    supplierName: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown())
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
    setQuotationDetails({
      ...quotationDetails,
      factoryID: '0'
    });
    setQuotationDetailsData([]);
  }, [quotationDetails.groupID]);

  useEffect(() => {
    setQuotationDetailsData([]);
    setQuotationDetails({
      ...quotationDetails,
      supplierID: '0',
    })
  }, [quotationDetails.factoryID]);

  useEffect(() => {
    setQuotationDetailsData([]);
    trackPromise(getQuotationsForDropDown());
    setQuotationDetails({
      ...quotationDetails,
      quotationHeaderID: 0,
    })
  }, [quotationDetails.supplierID]);

  useEffect(() => {
    trackPromise(getSuppliersForDropDown());
  }, [quotationDetails.factoryID, quotationDetails.groupID]);

  async function getPermissions() {
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWQUOTATIONCOMPLETE');

    if (!isAuthorized) {
      navigate('/404');
    }

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: !!permissions.find(
        p => p.permissionCode === 'GROUPDROPDOWN'
      ),
      isFactoryFilterEnabled: !!permissions.find(
        p => p.permissionCode === 'FACTORYDROPDOWN'
      )
    });

    setQuotationDetails({
      ...quotationDetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(quotationDetails.groupID);
    setFactories(factories);
  }

  async function getSuppliersForDropDown() {
    const suppliers = await services.GetSuppliersByItemIDAndFactoryID(quotationDetails.groupID, quotationDetails.factoryID);
    const formattedSuppliers = suppliers.map((supplier, index) => ({
      supplierID: index,
      supplierName: supplier
    }));
    setSuppliers(formattedSuppliers);
  }
  async function getQuotationsForDropDown() {
    const quotation = await services.GetQuotationsBySupplier(quotationDetails.groupID, quotationDetails.factoryID, quotationDetails.supplierID);
    setQuotations(quotation);
  }

  async function getQuotationDetails() {
    const AllQuotationDetails = await services.GetAllQuotationDetails(
      quotationDetails.groupID,
      quotationDetails.factoryID,
      quotationDetails.supplierID,
      quotationDetails.quotationHeaderID
    );
    if (AllQuotationDetails.statusCode === "Success" && Array.isArray(AllQuotationDetails.data) && AllQuotationDetails.data.length > 0) {
      const newQuotation = _.cloneDeep(AllQuotationDetails.data);
      newQuotation.forEach(x => {
        x.isOpen = false
      })
      setQuotationDetailsData(newQuotation);
    } else {
      alert.error("No Record to Display");
    }
  }

  useEffect(() => {
    const initializedData = QuotationDetailsData.map((row) => ({
      ...row,
      isExpireDateSet: !!row.expireDate,
    }));
    setQuotationDetailsData(initializedData);
  }, []);

  const uploadSelectedRequisitions = async () => {
    let newErrors = {};

    QuotationDetailsData.forEach((row, index) => {
      if (row.unitPrice == 0) {
        newErrors[index] = "Unit Price is required";
      }

      if (row.description && row.description !== row.description.trim()) {
        newErrors[`description_${index}`] = "Spaces are not allowed at the start or end.";
      }

      if (row.termsAndCondition && row.termsAndCondition !== row.termsAndCondition.trim()) {
        newErrors[`termsAndCondition_${index}`] = "Spaces are not allowed at the start or end.";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    if (Object.keys(errors).length > 0) {
      alert.error("Please fix validation errors before submitting.");
      return;
    }

    const mappedData = QuotationDetailsData.map((item) => ({
      ...item,
      description: item.description ? item.description.trim() : item.description,
      termsAndCondition: item.termsAndCondition ? item.termsAndCondition.trim() : item.termsAndCondition,
      warrentyPeriod: item.warrentyExpiryDate,
      warrentyExpiryDate: item.warrentyExpiryDate,
      createdBy: parseInt(tokenService.getUserIDFromToken()),
    }));

    const res = await services.uploadSelectedRequisitions(mappedData);
    if (res.statusCode === "Success") {
      alert.success(res.message);
      setQuotationDetailsData([]);
      setQuotationDetails({
        ...quotationDetails,
        supplierID: 0,
        quotationHeaderID: 0
      })
      setErrors({});
      navigate('/app/QuotationComplete/listing');
    } else {
      alert.error(res.message);
    }
  };

  function generateDropDownMenu(data) {
    return Object.entries(data || {}).map(([key, value]) => (
      <MenuItem key={key} value={key}>
        {value}
      </MenuItem>
    ));
  }

  const handleInputChange = (event, index) => {
    const value = event.target.value;
    const field = event.target.name;

    if (field === 'description' || field === 'termsAndCondition') {
      if (value !== value.trim() && value !== '') {
        const newErrors = { ...errors };
        newErrors[`${field}_${index}`] = 'Spaces are not allowed at the start or end.';
        setErrors(newErrors);
      } else {
        const newErrors = { ...errors };
        delete newErrors[`${field}_${index}`];
        setErrors(newErrors);
      }
    }

    const updatedData = QuotationDetailsData.map((item, i) => {
      if (i === index) {
        if (field === 'warrentyPeriod') {
          return {
            ...item,
            warrentyPeriod: value || null
          };
        }
        else if (field === 'unitPrice') {
          if (/^\d*\.?\d{0,2}$/.test(value)) {
            const numericValue = parseFloat(value) || 0;
            return {
              ...item,
              unitPrice: value,
              grossTotalPrice: numericValue * item.quantity,
              totalPrice: numericValue * item.quantity
            };
          } else {
            return item;
          }
        } else if (field === 'discount') {
          const numericDiscount = parseFloat(value) || 0;
          const unitPrice = parseFloat(item.unitPrice) || 0;
          const maxDiscount = unitPrice * item.quantity;

          if (numericDiscount > maxDiscount) {
            const newErrors = { ...errors };
            newErrors[`discount_${index}`] = 'Discount is too high';
            setErrors(newErrors);
          } else {
            const newErrors = { ...errors };
            delete newErrors[`discount_${index}`];
            setErrors(newErrors);
          }

          return {
            ...item,
            discount: value,
            totalPrice: maxDiscount - numericDiscount
          };
        }
        else {
          return {
            ...item,
            [field]: value
          };
        }
      }
      return item;
    });
    setQuotationDetailsData(updatedData);
  }

  const handleInputDateChange = (event, index) => {
    const value = event.target.value.trim();
    const field = event.target.name;

    const updatedData = QuotationDetailsData.map((item, i) => {
      if (i === index) {
        const updatedItem = { ...item, [field]: value };

        // if (field === 'expireDate') {
        //   updatedItem.isExpireDateSet = !!value;
        //   if (item.warrentyExpiryDate && item.warrentyExpiryDate >= value) {
        //     updatedItem.error = 'Warranty expiry date must be before the SKU expiry date.';
        //   } else {
        //     updatedItem.error = null;
        //   }
        // } else if (field === 'warrentyExpiryDate') {
        //   if (item.expireDate && value >= item.expireDate) {
        //     updatedItem.error = 'Warranty expiry date must be before the SKU expiry date.';
        //   } else {
        //     updatedItem.error = null;
        //   }
        // }

        return updatedItem;
      }
      return item;
    });

    setQuotationDetailsData(updatedData);
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setQuotationDetails({ ...quotationDetails, [name]: value });
  }

  function handleSearchDropdownChangeBuyer(event, value) {
    if (value) {
      setQuotationDetails((prevState) => ({
        ...prevState,
        supplierID: value.supplierID,
        supplierName: value.supplierName,
      }));
    } else {
      setQuotationDetails((prevState) => ({
        ...prevState,
        supplierID: 0,
        supplierName: '',
      }));
    }
    setQuotationDetailsData([]);
  }

  function handleSearchDropdownQuotation(event, value) {
    if (value) {
      setQuotationDetails((prevState) => ({
        ...prevState,
        quotationHeaderID: value.quotationHeaderID,
        quotationNumber: value.quotationNumber,
      }));
    } else {
      setQuotationDetails((prevState) => ({
        ...prevState,
        quotationHeaderID: 0,
        quotationNumber: '',
      }));
    }
    setQuotationDetailsData([]);
  }
  const handleClick = () => {
    navigate('/app/QuotationComplete/listing');
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Page className={classes.root} title="Complete Quotation ">
      <LoadingComponent />
      <Container maxWidth={false}>
        <Formik
          initialValues={quotationDetails}
          validationSchema={Yup.object({
            groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
            factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
            supplierID: Yup.number().required('Supplier is required').min(1, 'Supplier is required'),
          })}
          onSubmit={getQuotationDetails}
          enableReinitialize
        >
          {({ handleSubmit, errors, touched, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Card style={{ marginBottom: '1rem' }}
              >
                <CardHeader title={cardTitle('Complete Quotation')} />
                <Divider />
                <CardContent style={{ marginBottom: '2rem' }}>
                  <Grid container spacing={3}>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="groupID">
                        Group *</InputLabel>
                      <TextField
                        select
                        name="groupID"
                        value={quotationDetails.groupID}
                        onChange={handleChange}
                        error={touched.groupID && Boolean(errors.groupID)}
                        helperText={touched.groupID && errors.groupID}
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">Select Group</MenuItem>
                        {generateDropDownMenu(groups)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="factoryID">
                        Factory *</InputLabel>
                      <TextField
                        select
                        name="factoryID"
                        value={quotationDetails.factoryID}
                        onChange={handleChange}
                        error={touched.factoryID && Boolean(errors.factoryID)}
                        helperText={touched.factoryID && errors.factoryID}
                        fullWidth
                        variant="outlined"
                        size="small"
                      >
                        <MenuItem value="0">Select Factory</MenuItem>
                        {generateDropDownMenu(factories)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="supplierID">
                        Item Supplier *
                      </InputLabel>
                      <Autocomplete
                        id="supplierID"
                        options={suppliers || []}
                        size="small"
                        getOptionLabel={(option) => option?.supplierName || ''}
                        onChange={(event, value) => {
                          handleSearchDropdownChangeBuyer(event, value);
                        }}
                        value={
                          suppliers.find((supplier) => supplier?.supplierID === quotationDetails.supplierID) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={Boolean(touched.supplierID && errors.supplierID)}
                            helperText={touched.supplierID && errors.supplierID}
                            variant="outlined"
                            placeholder="--Select Supplier--"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="quotationHeaderID">
                        Quotation
                      </InputLabel>
                      <Autocomplete
                        id="quotationHeaderID"
                        options={quotations || []}
                        size="small"
                        getOptionLabel={(option) => option?.quotationNumber || ''}
                        onChange={(event, value) => {
                          handleSearchDropdownQuotation(event, value);
                        }}
                        value={
                          quotations.find((supplier) => supplier?.quotationHeaderID === quotationDetails.quotationHeaderID) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="--Select Quotation --"
                          />
                        )}
                      />
                    </Grid>
                    <Grid container justify="flex-end" spacing={3}>
                      <Box pr={2} style={{ marginTop: '20px' }}>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size="small"
                        >
                          Search
                        </Button >
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          )}
        </Formik>
        {QuotationDetailsData.length > 0 ? (
          <PerfectScrollbar>
            {QuotationDetailsData.map((rowData, index) => (
              <Card
                key={index}
                style={{ marginBottom: '1rem' }}
              >
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} size="small" aria-label="quotation table">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>{rowData.quotationNumber}</TableCell>
                        <TableCell align='center' >SKU</TableCell>
                        {/* <TableCell>SKU Expiry Date</TableCell>
                        <TableCell>Warranty Expiry Date</TableCell> */}
                        <TableCell align='right'>UOM</TableCell>
                        <TableCell align='right'>Quantity</TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align='right'>Unit Price *</TableCell>
                        <TableCell align='right'>Discount</TableCell>
                        <TableCell style={{ width: 100, height: 50, fontWeight: "bold" }} align='right'>Net Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {detailsOne.map((data) => {
                        const setOpen = (event) => {
                          const updatedData = [...QuotationDetailsData];
                          updatedData[index] = {
                            ...updatedData[index], isOpen: event,
                          };
                          setQuotationDetailsData(updatedData)
                        }
                        return (
                          <>
                            <TableRow>
                              <TableCell>
                                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!rowData.isOpen)}>
                                  {rowData.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                              </TableCell>
                              <TableCell align='center'>{rowData.skuMasterName}</TableCell>
                              {/* <TableCell>
                                <TextField
                                  name="expireDate"
                                  type="date"
                                  variant="outlined"
                                  size="small"
                                  value={rowData.expireDate || ""}
                                  onChange={(e) => handleInputDateChange(e, index)}
                                  onKeyDown={(e) => e.preventDefault()}
                                  InputProps={{
                                    inputProps: {
                                      min: new Date().toISOString().split("T")[0]
                                    }
                                  }}

                                />
                              </TableCell> */}
                              {/* <TableCell>
                                <TextField
                                  name="warrentyExpiryDate"
                                  type="date"
                                  variant="outlined"
                                  size="small"
                                  value={rowData.warrentyExpiryDate || ""}
                                  onChange={(e) => handleInputDateChange(e, index)}
                                  onKeyDown={(e) => e.preventDefault()}
                                  InputProps={{
                                    inputProps: {
                                      min: new Date().toISOString().split("T")[0],
                                      ...(rowData.expireDate ? { max: rowData.expireDate } : {}),
                                    },
                                  }}
                                  error={Boolean(rowData.error && rowData.isExpireDateSet)} // Show error only if expireDate is set
                                  helperText={rowData.isExpireDateSet ? rowData.error || "" : ""}
                                />
                              </TableCell> */}
                              <TableCell align='right'>
                                {rowData.measuringUnit}
                              </TableCell>
                              <TableCell align='right' >{rowData.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                              <TableCell align='right'>
                                <TextField
                                  name="unitPrice"
                                  variant="outlined"
                                  size="small"
                                  value={rowData.unitPrice}
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(/,/g, '');
                                    handleInputChange(e, index);
                                    if (errors[index] && inputValue > 0) {
                                      setErrors((prev) => {
                                        const updatedErrors = { ...prev };
                                        delete updatedErrors[index];
                                        return updatedErrors;
                                      });
                                    }
                                  }}
                                  error={Boolean(errors[index])}
                                  helperText={errors[index] || ""}
                                  sx={{ width: "150px", textAlign: 'right' }}
                                  InputProps={{
                                    inputProps: { style: { textAlign: 'right' } },
                                  }}
                                />
                              </TableCell>
                              <TableCell align='right'>
                                <TextField
                                  name="discount"
                                  variant="outlined"
                                  size="small"
                                  value={rowData.discount}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                      handleInputChange(e, index);
                                    }
                                  }}
                                  error={Boolean(errors[`discount_${index}`])}
                                  helperText={errors[`discount_${index}`] || ""}
                                  sx={{ width: "150px", textAlign: 'right' }}
                                  InputProps={{
                                    inputProps: { style: { textAlign: 'right' } },
                                  }}
                                />
                              </TableCell>
                              <TableCell align='right'>{rowData.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell ></TableCell>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                <Collapse in={rowData.isOpen} timeout="auto" unmountOnExit>
                                  <Box margin={1}>
                                    <Table size="small" aria-label="purchases">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align="left" style={{ borderBottom: 'none', fontWeight: "bold" }}>Factory</TableCell>
                                          <TableCell align="left" style={{ borderBottom: 'none', fontWeight: "bold" }}>Requisition</TableCell>
                                          <TableCell align="right" style={{ borderBottom: 'none', fontWeight: "bold" }}>Quantity</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {rowData.quotationCompleteModels.map((historyRow, i) => (
                                          <TableRow key={i}>
                                            <TableCell align="left" style={{ borderBottom: 'none' }}>
                                              {historyRow.factoryName}
                                            </TableCell>
                                            <TableCell align="left" style={{ borderBottom: 'none' }}>
                                              {historyRow.requisitionNumber}
                                            </TableCell>
                                            <TableCell align="right" style={{ borderBottom: 'none' }}>
                                              {historyRow.quantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </Box>
                                </Collapse>
                              </TableCell>
                              <TableCell ></TableCell>
                              <TableCell ></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={2}>
                                <strong>Description</strong>
                              </TableCell>
                              <TableCell colSpan={7}>
                                <TextField
                                  name="description"
                                  type="text"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={rowData.description || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                  error={Boolean(errors[`description_${index}`])}
                                  helperText={errors[`description_${index}`] || ""}
                                  sx={{ width: "100px" }}
                                />
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell colSpan={2}>
                                <strong>Terms and Conditions</strong>
                              </TableCell>
                              <TableCell colSpan={7}>
                                <TextField
                                  name="termsAndCondition"
                                  type="text"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={rowData.termsAndCondition || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                  error={Boolean(errors[`termsAndCondition_${index}`])}
                                  helperText={errors[`termsAndCondition_${index}`] || ""}
                                  sx={{ width: "100px" }}
                                />
                              </TableCell>
                            </TableRow>
                          </>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            ))}
            <Box mt={1} display="flex" justifyContent="flex-end" width="90%" margin="auto">
              <Button color="primary" variant="contained" onClick={uploadSelectedRequisitions}>
                Complete
              </Button>
            </Box>
          </PerfectScrollbar>
        ) : null}
      </Container>
    </Page>
  );
}
